import logout from '@/mixins/logout.js'
import {
  UPLOAD_INFO,
  SME_UPLOAD_INFO,
  HNI_UPLOAD_INFO
} from '@/utils/constants'

export default {
  mixins: [logout],
  methods: {
    submitKycDetailsStep (payload) {
      payload.type = this.businessType
      this.isLoading = true
      const vm = this
      this.$store
        .dispatch('kyc/submitKycDetailsStep', payload)
        .then((res) => {
          vm.$message({
            showClose: true,
            message: res.data.message || 'Kyc updated successfully',
            type: 'success'
          })

          this.getKycDetails()
          const businessSteps = this.isBusinessTypeHNI ? [1, 2] : [1, 2, 3, 4]
          const directorSteps = this.isBusinessTypeHNI ? [3, 4] : [5, 6]

          if (businessSteps.includes(this.kycStep)) {
            this.business.show = false
          } else if (directorSteps.includes(this.kycStep)) {
            this.director.show = false
          } else {
            this.business.show = false
          }
        })
        .catch((error) => {
          const err = error.response.data.error.publicMessage
          if (error.response.data.code !== 401) {
            vm.$message({
              showClose: true,
              message: err || this.httpErrorMessage.customMessage,
              type: 'error'
            })
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    submitKycDetailsStepFormUpload (payload) {
      payload.type = this.businessType
      this.isLoading = true
      const vm = this
      this.$store
        .dispatch('kyc/submitKycDetailsStepFormUpload', payload)
        .then((res) => {
          vm.$message({
            showClose: true,
            message: res.data.message || 'Kyc submitted successfully',
            type: 'success'
          })

          this.getKycDetails()
          if (!this.isBusinessTypeHNI && this.kycStep === 5) {
            this.handleClose()
          } else {
            this.upload.show = false
          }
        })
        .catch((error) => {
          const err = error.response.data.error.publicMessage
          if (error.response.data.code !== 401) {
            vm.$message({
              showClose: true,
              message: err || this.httpErrorMessage.customMessage,
              type: 'error'
            })
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    submitKycFinalStage () {
      this.isLoading = true
      const vm = this
      this.$store
        .dispatch('kyc/submitKycFinalStage')
        .then(() => {
          this.isLoading = false
          this.getKycDetails()
          this.$router.push('/submit-kyc/kyc-completed')
        })
        .catch((error) => {
          const err = error.response.data.error.publicMessage
          if (error.response.data.code !== 401) {
            vm.$message({
              showClose: true,
              message: err || this.httpErrorMessage.customMessage,
              type: 'error'
            })
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async getKycDetails () {
      this.isLoading = true
      const vm = this
      await this.$store
        .dispatch('kyc/getKycDetails')
        .then(() => {
          if (this.isInDisputeStage) {
            this.getKycDisputes(this.businessId)
          }
          this.isLoading = false
        })
        .catch((error) => {
          const err = error.response.data.error.publicMessage
          if (error.response.data.code === 401 && this.accessToken) {
            setTimeout(() => {
              this.getKycDetails()
            }, 3000)
          } else {
            vm.$message({
              showClose: true,
              message: err || this.httpErrorMessage.customMessage,
              type: 'error'
            })
            this.isLoading = true
            this.$router.push('/login')
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async getKycDisputes (businessId) {
      this.isLoading = true
      const vm = this
      await this.$store
        .dispatch('kyc/getKycDisputes', businessId)
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          const err = error.response.data.error.publicMessage
          if (error.response.data.code === 401 && this.accessToken) {
            setTimeout(() => {
              this.getKycDetails()
            }, 3000)
          } else {
            vm.$message({
              showClose: true,
              message: err || this.httpErrorMessage.customMessage,
              type: 'error'
            })
            this.isLoading = true
            this.$router.push('/login')
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async removeDirector () {
      this.isLoading = true
      const vm = this
      await this.$store
        .dispatch('kyc/removeDirector', this.selectedDirector.id)
        .then((res) => {
          this.isLoading = false
          this.getKycDetails()
          this.handleClose()

          vm.$message({
            showClose: true,
            message:
              res.data.message || 'Director details deleted successfully',
            type: 'success'
          })
        })
        .catch((error) => {
          const err = error.response.data.error.publicMessage
          if (error.response.data.code !== 401) {
            vm.$message({
              showClose: true,
              message: err || this.httpErrorMessage.customMessage,
              type: 'error'
            })
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    disabledDate (time) {
      return new Date(time).getTime() > new Date().getTime()
    },
    remoteMethod (query) {
      const queryLowerCase = query.toLowerCase()
      this.options = this.allCountries.filter((item) =>
        item.name.toLowerCase().includes(queryLowerCase)
      )
    },
    handleRemoveDoc () {
      this.removeDoc = true
    },
    handleChange (event) {
      this.fileChoosen = true
      this.disabled = false
      this.file = event.target.files[0]
    },
    handleRemoveFile () {
      const input = document.getElementById(this.id)

      this.fileChoosen = false
      this.file = {}
      this.disabled = true
      input.value = ''
    },
    getItemsByStep (step) {
      if (this.isBusinessTypeHNI) {
        return step === 1
          ? this.hniBusinessInfo
          : step === 2
          ? this.hniDirectorsInfo
          : this.hniUploadInfo
      } else {
        return step === 1
          ? this.businessInfo
          : step === 2
          ? this.directorsInfo
          : this.uploadInfo
      }
    }
  },
  computed: {
    accessToken () {
      return this.$store.state.auth.accessToken
    },
    isBusinessTypeHNI () {
      return this.$store?.state?.auth?.business?.businessType === 'hni'
    },
    isBusinessTypeSME () {
      return this.$store?.state?.auth?.business?.businessType === 'sme'
    },
    businessId () {
      return this.$store?.state?.auth?.business?.id
    },
    stepStatus () {
      return this.$store?.state.kyc.stepStatus || []
    },
    submittedStages () {
      return this.stepStatus
        .filter((item) => ['approved', 'submitted'].includes(item.status))
        .map((item) => parseInt(item.stage))
    },
    submittedDocuments () {
      const documentStage = this.stepStatus.find(
        (item) => item.stage === (this.isBusinessTypeHNI ? '5' : '7')
      )
      return Array.isArray(documentStage?.status)
        ? documentStage.status
            .filter((item) => ['approved', 'submitted'].includes(item.status))
            .map((item) => item.stage)
        : []
    },
    approvedDocuments () {
      const documentStage = this.stepStatus.find(
        (item) => item.stage === (this.isBusinessTypeHNI ? '5' : '7')
      )
      return Array.isArray(documentStage?.status)
        ? documentStage.status
            .filter((item) => ['approved'].includes(item.status))
            .map((item) => item.stage)
        : []
    },
    disputedDocuments () {
      const documentStage = this.stepStatus.find(
        (item) => item.stage === (this.isBusinessTypeHNI ? '5' : '7')
      )
      return Array.isArray(documentStage?.status)
        ? documentStage.status
            .filter((item) => ['in_dispute'].includes(item.status))
            .map((item) => item.stage)
        : []
    },
    approvedStages () {
      return this.stepStatus
        .filter((item) => ['approved'].includes(item.status))
        .map((item) => parseInt(item.stage))
    },
    disputedStages () {
      return this.stepStatus
        .filter((item) => ['in_dispute'].includes(item.status))
        .map((item) => parseInt(item.stage))
    },
    businessType () {
      return this.$store.state.auth?.business?.businessType || ''
    },
    allDocuments () {
      const contactType = this.isBusinessTypeHNI ? 'natural_person' : 'company'
      const documents =
        this.$store?.state.kyc?.kycDetails?.contacts?.find(
          (item) => item.contactType === contactType
        )?.documents || []
      return documents
    },
    kycDisputes () {
      return this.$store?.state.kyc.kycDisputes || []
    },
    stageDispute () {
      return this.kycDisputes.find((dispute) => dispute.stage === this.kycStep)
    },
    isDocApproved () {
      return this.approvedDocuments
        ? this.approvedDocuments.includes(this.upload?.document)
        : false
    },
    documentDispute () {
      const documentStage = this.isBusinessTypeHNI ? 5 : 7
      const allDocDisputes = this.kycDisputes.filter(
        (dispute) => dispute.stage === documentStage
      )
      return allDocDisputes.find(
        (item) => item.subStage === this.upload.document
      )
    },
    isInDisputeStage () {
      const disputedStages =
        this.stepStatus
          .filter((item) => ['in_dispute'].includes(item.status))
          .map((item) => parseInt(item.stage)).length || 0
      const documentStage = this.stepStatus.find(
        (item) => item.stage === (this.isBusinessTypeHNI ? '5' : '7')
      )
      const disputedDocs = Array.isArray(documentStage?.status)
        ? documentStage.status
            .filter((item) => ['in_dispute'].includes(item.status))
            .map((item) => item.stage).length
        : 0

      return disputedStages + disputedDocs > 0
    },
    hasCompletedKycStages () {
      return this.$store.state.kyc.kycDetails?.reviewStatus === 'pending_review'
    },
    kycProgressPercentage () {
      const docs = this.isBusinessTypeHNI
        ? HNI_UPLOAD_INFO
        : this.isBusinessTypeSME
        ? SME_UPLOAD_INFO
        : UPLOAD_INFO
      const filtered = docs
        .filter((item) => item.isCompulsory)
        .map((item) => item.document)
      const compulsoryDocs = this.submittedDocuments.filter((doc) =>
        filtered.includes(doc)
      )

      const completedStages =
        this.submittedStages?.length + compulsoryDocs?.length
      const totalStages = this.isBusinessTypeHNI
        ? 8
        : this.isBusinessTypeSME
        ? 14
        : 16
      const total = Math.round((completedStages / totalStages) * 100)

      return Math.min(total, 100)
    },
    uboShares10Plus () {
      const contacts = this.$store.state?.kyc?.kycDetails?.contacts || []
      const ubo = contacts.find(
        (item) =>
          item?.contactType === 'natural_person' &&
          item?.type === 'ubo' &&
          parseFloat(item?.shareholding) > 10
      )
      return ubo || false
    }
  }
}
